import { parsePhoneNumber } from 'libphonenumber-js';

export const validatePhoneNumber = (phoneNumber: string) => {
  try {
    // regex to check if the phone number has only digits and + sign
    const phoneRegex = /^[0-9+]+$/;

    if (!phoneRegex.test(phoneNumber)) {
      return false;
    }

    return parsePhoneNumber(phoneNumber)?.isValid();
  } catch {
    return false;
  }
};
